<template>
	<div class="pt-4">
		<div v-if="$route.name === 'job-evaluation-process-disenar-escala'">

			<app-table-disenar-escala
				@showChartClick="onShowChartClicked"
			/>

			<app-table-disenar-escala-header></app-table-disenar-escala-header>

			<app-table-disenar-escala-data
				:rows="rows"
			>
				<template slot="rows" slot-scope="props">
					<span class="Puesto-elemento">{{ props.row.name }}</span>
					<span class="Cant-elemento">{{ props.row.quantityPerson }}</span>
					<span class="Promedio-elemento">{{ props.row.average }}</span>
					<span class="Redondear-elemento">{{ props.row.roundedAverage }}</span>
					<span class="Sueldo-elemento">{{ props.row.currentSalary }}</span>
					<span class="SueldoTotal-elemento">{{ props.row.currentSalaryTotal }}</span>
					<span class="SueldoIdeal-elemento">{{ props.row.idealSalary }}</span>
				</template>
			</app-table-disenar-escala-data>

			<app-table-disenar-escala-orange
				:rows="Orows"
			>
				<template slot="Orows" slot-scope="props">
					<span class="Orange-Puesto-elemento">{{ props.row.name }}</span>
				</template>
			</app-table-disenar-escala-orange>

			<app-table-disenar-escala-Odata
				:rows="Orows"
			>
				<template slot="ODrows" slot-scope="props">
					<span class="Orange-Data-elemento">{{ props.row.average }}</span>
				</template>
			</app-table-disenar-escala-Odata>

			<app-table-disenar-escala-grafico
				:levels="Orows"
				:current-payroll="payrollData.currentPayroll"
				:ideal-payroll="payrollData.idealPayroll"
			></app-table-disenar-escala-grafico>
		</div>
		<design-scale-chart-modal v-model="showChartModal" :data="chartData" />
	</div>
</template>

<script>
	import appButton from '@/components/shared/app-button';
	import openModal from '@/components/configuration/open-modal';
	import DesignScaleChartModal from '@/modules/job-evaluation/components/process/design-scale/design-scale-chart-modal';
	import { pluck } from 'ramda';

	function created() {
		this.loadCommitted();
		this.loadOrange();
	}

	async function loadCommitted() {
		const params = {
			search: this.search,
			typeGroup: 2,
			averages: true,
		};
		try {
			const { data: response } = await this.$httpPraktiko.get(
				'groups', { params });
			this.rows = response;
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadOrange() {
		try {
			const { data: Oresponse } = await this.$httpPraktiko.get(
				'diagnostic-detail/JEV/summary?averages=true');
			this.Orows = Oresponse.levels;
			this.payrollData = {
				currentPayroll: Oresponse.additionalInformation.currentPayroll || 0,
				idealPayroll: Oresponse.additionalInformation.idealPayroll || 0,
			};
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			}
		}
	}

	function data() {
		return {
			newArray: [],
			action: null,
			arrayDiagnostic: {},
			// averageListo: [],
			arrayJobs: [],
			arrayEmployes: [],
			// columns: [
			// 	{ id: 1, name: 'Nombre de Comité', visible: true, checked: true },
			// 	{ id: 2, name: 'Fecha', visible: true, checked: true },
			// 	{ id: 3, name: 'Cantidad de Puestos', visible: true, checked: true },
			// 	{ id: 4, name: 'Cantidad por Valoradores', visible: true, checked: true },
			// 	{ id: 5, name: 'Acciones', visible: true, checked: true },
			// ],
			commiteeName: '',
			isVisible: false,
			rows: [],
			Orows: [],
			ODrows: [],
			payrollData: {
				currentPayroll: 0,
				idealPayroll: 0,
			},
			search: null,
			title: '',
			openDialog: false,
			showChartModal: false,
		};
	}

	export default {
		name: 'page-disenar-escala',
		created,
		data,
		components: {
			DesignScaleChartModal,
			appButton,
			openModal,
		},
		computed: {
			chartData() {
				return {
					labels: pluck('name', this.rows),
					currentSalaries: pluck('currentSalary', this.rows),
					idealSalaries: pluck('idealSalary', this.rows),
					averages: pluck('roundedAverage', this.rows),
				};
			},
		},
		methods: {
			loadCommitted,
			loadOrange,
			onShowChartClicked() {
				this.showChartModal = true;
			},
		},
	};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/disenarescala/page-disenar-escala.vue